import { render } from "./AnimateSvg.vue?vue&type=template&id=08285a80&scoped=true"
import script from "./AnimateSvg.vue?vue&type=script&lang=js"
export * from "./AnimateSvg.vue?vue&type=script&lang=js"

import "./AnimateSvg.vue?vue&type=style&index=0&id=08285a80&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08285a80"]])

export default __exports__